import React from 'react';
import { Grid, useTheme } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import KpiCard from './KpiCard';

const formatInt = (n) => {
  if (n === undefined || n === null) return '0';
  return Number(n).toLocaleString();
};

const KpiGrid = ({ kpis, translate }) => {
  const theme = useTheme();
  const accent = theme.palette.primary.main;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_products')}
          value={formatInt(kpis?.totalProducts)}
          icon={Inventory2OutlinedIcon}
          accent={accent}
          to="/products"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_skus')}
          value={formatInt(kpis?.totalSkus)}
          icon={QrCode2Icon}
          accent={accent}
          to="/products"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_orders')}
          value={formatInt(kpis?.totalOrders)}
          icon={ShoppingCartOutlinedIcon}
          accent={accent}
          to="/orders"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_open_orders')}
          value={formatInt(kpis?.openOrders)}
          icon={HourglassEmptyOutlinedIcon}
          accent={accent}
          to="/orders"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_customers')}
          value={formatInt(kpis?.totalCustomers)}
          icon={PeopleOutlineOutlinedIcon}
          accent={accent}
          to="/customers"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_medias')}
          value={formatInt(kpis?.totalMedias)}
          icon={PermMediaOutlinedIcon}
          accent={accent}
          to="/medias"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <KpiCard
          title={translate('home.dashboard.kpi_users')}
          value={formatInt(kpis?.totalUsers)}
          icon={GroupOutlinedIcon}
          accent={accent}
          to="/users"
        />
      </Grid>
    </Grid>
  );
};

export default KpiGrid;
